export enum HttpErrorMessagesEnum {
  INVALID = 'Invalid token',
  INVALID_FORMAT = 'Invalid token format',
  NOT_AUTHORIZED = 'Not authorized',
}
